var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1GroupLessons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.41 63.58V70h-24v-6.42A4.53 4.53 0 0148.86 59H64a4.53 4.53 0 014.41 4.58zM62 14H46v3h16v-3zm-2.47 41.93a5 5 0 10-6.204-7.843 5 5 0 006.204 7.843zM46 23h9v-3h-9v3zM39 7v16h3V10h24v17H45v3h24V7H39zM28.48 26.93A13.22 13.22 0 0017.85 22H7v21h16V28.86L37 44.6a2.65 2.65 0 003.73.23 3 3 0 00.64-.82 2.73 2.73 0 00-.45-3.08l-12.44-14zM35.53 59H20.44A4.53 4.53 0 0016 63.58V70h24v-6.42A4.53 4.53 0 0035.53 59zm-4.41-3.07a5 5 0 10-6.204-7.843 5 5 0 006.204 7.843zM18 18.19a6 6 0 10-7.443-9.412A6 6 0 0018 18.19z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Group_lessons.6fe103c0.svg";
export { SvgF1GroupLessons as ReactComponent };